import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import Dashboards from 'pages/dashboards/Dashboards';
import displayApplicationVersion from 'constants/appVersion.constant';
import PropTypes from 'prop-types';
import { setupAxios } from './utility';
import { compassStore } from './store';

function App({ instance }) {
  displayApplicationVersion();
  setupAxios();

  return (
    <div className="root-container container-xxl px-4 px-xxl-0">
      <div className="row">
        <div className="col-12">
          <BrowserRouter>
            <Provider store={compassStore}>
              <MsalProvider instance={instance}>
                <Dashboards />
              </MsalProvider>
            </Provider>
          </BrowserRouter>
        </div>
      </div>
    </div>
  );
}

App.propTypes = {
  instance: PropTypes.instanceOf(PublicClientApplication).isRequired,
};
export default App;
